import { render, staticRenderFns } from "./portfolioitem.vue?vue&type=template&id=4c8ec942&scoped=true&"
import script from "./portfolioitem.vue?vue&type=script&lang=js&"
export * from "./portfolioitem.vue?vue&type=script&lang=js&"
import style0 from "./portfolioitem.vue?vue&type=style&index=0&id=4c8ec942&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8ec942",
  null
  
)

export default component.exports